module.exports = __webpack_public_path__ + "static/axo_social-0a23cac065d923453fbe6137a192ec30.png";